/* NOVAIRE product form — variant buttons, purchase options (selling plans),
   quantity stepper, and gallery thumbs. Reads variant data from the JSON
   script tag rendered by sections/main-product.liquid. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var amountNoDecimals = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (parts[1] === '00') amount = amountNoDecimals + '.00';
    var f = format || '${{amount}}';
    return f
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimals);
  }

  document.querySelectorAll('[data-nv-product]').forEach(function (container) {
    var dataEl = container.querySelector('[data-nv-variant-data]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var moneyFormat = container.getAttribute('data-money-format') || '${{amount}}';
    var idInput = container.querySelector('[data-nv-variant-id]');
    var planInput = container.querySelector('[data-nv-plan-input]');
    var priceEl = container.querySelector('[data-nv-price]');
    var qtyInput = container.querySelector('[data-nv-qty]');

    var state = {
      variantId: idInput ? parseInt(idInput.value, 10) : (variants[0] && variants[0].id),
      planId: planInput && planInput.value ? parseInt(planInput.value, 10) : null
    };

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === state.variantId) return variants[i];
      }
      return variants[0];
    }

    function planPrice(variant, planId) {
      if (!planId || !variant.plans) return null;
      for (var i = 0; i < variant.plans.length; i++) {
        if (variant.plans[i].id === planId) return variant.plans[i].price;
      }
      return null;
    }

    function render() {
      var variant = currentVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (planInput) planInput.value = state.planId || '';

      var price = variant.price;
      var subPrice = planPrice(variant, state.planId);
      if (subPrice !== null) price = subPrice;
      if (priceEl) priceEl.textContent = formatMoney(price, moneyFormat);

      container.querySelectorAll('[data-nv-variant-btn]').forEach(function (btn) {
        var active = parseInt(btn.getAttribute('data-variant-id'), 10) === variant.id;
        btn.classList.toggle('nv-variants__btn--active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      container.querySelectorAll('[data-nv-plan-option]').forEach(function (opt) {
        var raw = opt.getAttribute('data-plan-id') || '';
        var optPlan = raw === '' ? null : parseInt(raw, 10);
        var active = optPlan === state.planId;
        opt.classList.toggle('nv-purchase__option--active', active);
        opt.setAttribute('aria-pressed', active ? 'true' : 'false');
        var priceSpan = opt.querySelector('[data-nv-plan-price]');
        if (priceSpan) {
          var p = optPlan === null ? variant.price : planPrice(variant, optPlan);
          if (p !== null) priceSpan.textContent = formatMoney(p, moneyFormat);
        }
      });

      var addBtn = container.querySelector('[data-nv-add-to-cart]');
      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.textContent = addBtn.getAttribute('data-label-add');
        } else {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.getAttribute('data-label-sold-out');
        }
      }
    }

    container.addEventListener('click', function (e) {
      var vBtn = e.target.closest('[data-nv-variant-btn]');
      if (vBtn) {
        e.preventDefault();
        state.variantId = parseInt(vBtn.getAttribute('data-variant-id'), 10);
        var v = currentVariant();
        if (state.planId && planPrice(v, state.planId) === null) {
          // No one-time option in the DOM means the product requires a selling
          // plan — fall back to the variant's first plan, not to one-time.
          var oneTime = container.querySelector('[data-nv-plan-option][data-plan-id=""]');
          state.planId = (!oneTime && v.plans && v.plans.length) ? v.plans[0].id : null;
        }
        render();
        return;
      }
      var pBtn = e.target.closest('[data-nv-plan-option]');
      if (pBtn) {
        e.preventDefault();
        var raw = pBtn.getAttribute('data-plan-id') || '';
        state.planId = raw === '' ? null : parseInt(raw, 10);
        render();
        return;
      }
      var qBtn = e.target.closest('[data-nv-qty-step]');
      if (qBtn && qtyInput) {
        e.preventDefault();
        var next = parseInt(qtyInput.value || '1', 10) + parseInt(qBtn.getAttribute('data-nv-qty-step'), 10);
        qtyInput.value = Math.max(1, next);
        return;
      }
      var thumb = e.target.closest('[data-nv-thumb]');
      if (thumb) {
        e.preventDefault();
        container.querySelectorAll('[data-nv-thumb]').forEach(function (t) {
          t.classList.remove('nv-product__thumb--active');
        });
        thumb.classList.add('nv-product__thumb--active');
        var main = container.querySelector('[data-nv-main-image]');
        if (!main) return;
        var src = thumb.getAttribute('data-image-src');
        var img = main.querySelector('img');
        if (src) {
          if (img) {
            img.src = src;
            img.srcset = thumb.getAttribute('data-image-srcset') || '';
          }
        } else if (!img) {
          main.style.background = thumb.getAttribute('data-tone') || '';
        }
      }
    });

    render();
  });
})();
